import { features } from '../environment/features';

export function samplePage() {
	if (!features.gitContributors) {
		const contributorListElement = document.querySelector<HTMLElement>('.contributors-holder');
		contributorListElement.parentElement.removeChild(contributorListElement);
	}
}
